export default __webpack_public_path__ + "static/media/tag-right.f83c60ae.svg";